export default "__VITE_ASSET__B9w1CM_W__"